import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import Auth, { AuthenticationProvider } from "@creditsafe/upp-authentication";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { userSignedIn } from "./store/UserSlice";
import { createBrowserHistory } from "history";
import { AppWrapper } from "./AppWrapper";
import { initI18nClient } from "./i18n";
import { registerLocale } from "i18n-iso-countries";
import config from "./config";
import { initStandaloneAuthSessionCleanup } from "./utils/auth-session/auth-session";

const i18nextLng = localStorage.getItem("i18nextLng");
const userLocale = i18nextLng !== null ? i18nextLng?.slice(0, 2) : "en"; //i18n.language will return en-GB for example, then extract the iso country code

/* eslint @typescript-eslint/no-var-requires: "off" */
registerLocale(require(`i18n-iso-countries/langs/${userLocale}.json`)); // Registering the User Locale

const queryClient = new QueryClient();
const rootElement = document.getElementById("root") as Element;
const root = createRoot(rootElement);

console.warn("root after module federation", root, rootElement);

const history = createBrowserHistory();
const isUpp = false;

const bootstrap = async (): Promise<void> => {
  await initI18nClient(isUpp);

  Auth.configure({
    appName: "compliance-app",
    authority: config?.MY_LOGIN_URL,
    level: 3,
    scope:
      "openid profile upp_api connect_web ubo_api_gateway ubo_elastic_api data_cloud_api",
  });

  await initStandaloneAuthSessionCleanup();

  root.render(
    <Provider store={store}>
      <AuthenticationProvider
        onSignin={(oidcUser: { access_token?: string }) => {
          if (oidcUser?.access_token) {
            store.dispatch(userSignedIn(oidcUser.access_token));
          }
        }}
        history={history}
      >
        <QueryClientProvider client={queryClient}>
          <AppWrapper
            isUpp={isUpp}
            clearKycRedirectAction={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </QueryClientProvider>
      </AuthenticationProvider>
    </Provider>,
  );
};

void bootstrap();
